import _ from 'lodash';
import { CountryAcronym, CountryEnum } from './enuns/country.enum';
import { KeyValue } from './models/keyValue.model';

export type supportedCountries = CountryEnum.Brasil |
    CountryEnum.Argentina |
    CountryEnum.Peru |
    CountryEnum.Chile |
    CountryEnum.Colombia |
    CountryEnum.Equador |
    CountryEnum.Uruguai |
    CountryEnum.RepublicaDominicana |
    CountryEnum.Guatemala |
    CountryEnum.ElSalvador |
    CountryEnum.Panama;

// SERIALIZE STRINGS
function jquerySerializeObject() {
    const arrayData = this.serializeArray();
    const objectData = {};

    function eachData() {
        const value = this.value ? this.value : '';

        if (objectData[this.name]) {
            if (!objectData[this.name].push) {
                objectData[this.name] = [objectData[this.name]];
            }

            return objectData[this.name].push(value);
        }
        objectData[this.name] = value;
    }

    $.each(arrayData, eachData);

    return objectData;
}

jQuery.fn.serializeObject = jquerySerializeObject;

function jqueryIsVisible() {
    return this.is(':visible');
}

jQuery.fn.isVisible = jqueryIsVisible;

export const getParameterByName = (name, url) => {
    if (!url) {
        url = window.location.search;
    }

    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) {
        return null;
    }

    if (!results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getUrlParams = () =>
    _.reduce(decodeURIComponent(window.location.search.slice(1)).split('&'), (a, b) => {
        b = b.split('=');
        a[b[0]] = b[1];
        return a;
    }, {});

// CAMELCASE
function stringToCapitalCase() {
    return this.replace(/\w\S*/g, str => str.charAt(0).toUpperCase() + str.substr(1).toLowerCase());
}

String.prototype.toCapitalCase = stringToCapitalCase;

// REMOVE ACCENTS ON STRINGS
function stringToASCII() {
    const words = this.split('');
    const wordsOut = [];
    const wordsLen = words.length;
    const accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽžº´';
    const accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZzo_';
    let i = 0;

    while (i < wordsLen) {
        if (accents.indexOf(words[i]) !== -1) {
            wordsOut[i] = accentsOut.substr(accents.indexOf(words[i]), 1);
        } else {
            wordsOut[i] = words[i];
        }

        i += 1;
    }

    return wordsOut.join('');
}

String.prototype.toASCII = stringToASCII;

function stringToUnderscoreCase() {
    return this.toASCII().replace(/\W+/g, '_').toLowerCase();
}

String.prototype.toUnderscoreCase = stringToUnderscoreCase;

function arrayContains(el) {
    return this.indexOf(el) > -1;
}

Array.prototype.contains = arrayContains;

function arrayDiff(el) {
    return this.filter(x => el.indexOf(x) < 0);
}

Array.prototype.diff = arrayDiff;

function arrayMax() {
    return Math.max.apply(null, this);
}

Array.prototype.max = arrayMax;

function arrayMin() {
    return Math.min.apply(null, this);
}

Array.prototype.min = arrayMin;

function arrayUniq() {
    return this.filter((elem, index, self) => index === self.indexOf(elem));
}

Array.prototype.uniq = arrayUniq;

function arrayOrderBy(options) {
    if (!options) {
        return this;
    }

    return this.sort(() => {
        const sortOrder = options.reverse ? options.reverse : -{ 1: 1 };
        return (a, b) => {
            const valueA = a[options.field];
            const valueB = b[options.field];

            if (_.isNumber(valueA) && _.isNumber(valueB)) {
                return (valueA - valueB) * sortOrder;
            }
            const result =
                valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
            return result * sortOrder;
        };
    });
}

Array.prototype.orderBy = arrayOrderBy;

function arrayToUpperCase() {
    return this.map(x => x.toUpperCase());
}

Array.prototype.toUpperCase = arrayToUpperCase;

function arrayToCapitalCase() {
    return this.map(x => x.toCapitalCase());
}

Array.prototype.toCapitalCase = arrayToCapitalCase;

function arrayIsEqual(el) {
    const arraysEqual = function (a, b) {
        if (a === b) {
            return true;
        }

        if (a === null || b === null) {
            return false;
        }

        if (a.length !== b.length) {
            return false;
        }

        let i = 0;
        while (i < a.length) {
            if (a[i] !== b[i]) {
                return false;
            }

            i += 1;
        }

        return true;
    };

    return arraysEqual(this, el);
}

Array.prototype.isEqual = arrayIsEqual;

export const tryOrReturn = (callback, ret) => {
    try {
        const result = callback();
        return result;
    } catch (err) {
        console.log(err);
        return ret;
    }
};

Array.prototype.findOrFirst = function <T>(predicate: (obj: T) => boolean): T {
    return this.find(predicate) || this[0];
};

Array.prototype.findOrReturn = function <T>(predicate: (obj: T) => boolean, defaultValue: T): T {
    return this.find(predicate) || defaultValue;
};

Array.prototype.distinctBy = function <T>(selector: <TProp>(obj: T) => TProp): Array<T> {
    return this.filter((obj, index, list) => list.map(x => selector(x)).indexOf(selector(obj)) === index);
};

Array.prototype.sumBy = function <T>(selector: (obj: T) => number): number {
    return this.reduce((agg, crr) => agg + selector(crr), 0);
};


export const getFAIcon = faIcon => `fa-${faIcon}`;

export const getWithDotComByCountry = (country) => {
    const countryNotCom = ['cl', 'gt'];

    return countryNotCom.indexOf(country) === -1
        ? '.com.'
        : '.';
};

export const getCountry = (): supportedCountries => {
    const allowedCountries = Object.keys(CountryAcronym).map(x => x.toUpperCase());
    const currentCountry = location.hostname.toUpperCase().split('.').pop();

    return allowedCountries.includes(currentCountry) ? currentCountry.toLowerCase() : CountryEnum.Brasil.toLowerCase();
};

export const getManualByCountry = (country, docHost) => {
    const manuals = {
        spanish: `${docHost}/es/`,
        english: `${docHost}/en/`,
        portuguese: `${docHost}/pt-BR/`,
    };

    const languageSelected = localStorage.getItem("language");

    switch (languageSelected) {
        case "es-BR":
        case "es-AS":
            return manuals.spanish;

        case "en-BR":
        case "en-AS":
            return manuals.english;

        case "pt-BR":
        case "pt-AS":
            return manuals.portuguese;

        default:
            return country.toLowerCase() !== CountryEnum.Brasil.toLowerCase()
                ? manuals.spanish
                : manuals.portuguese;
    }
};

export const transformToKeyValue = (targetEnum: any) => {
    let result = [];
    for (let enumMember in targetEnum) {
        const valueProperty = parseInt(targetEnum[enumMember], 10);
        if (valueProperty >= 0) {
            result.push(new KeyValue(enumMember, valueProperty));
        }
    }

    return result;
};

export const setExportActionCss = (decrementSize) => {
    const decrement = decrementSize || 60;
    $('.infoboard-tabs .panel-group').parent().css('height', '100%');
    $('.infoboard-tabs .panel-group').css('height', `calc(100% - ${decrement}px)`);
};

export const hidePanelSelectionAlert = () => {
    $('.infoboard-tabs')
        .find('.panel-title')
        .toArray()
        .filter(el => el.isOpen)
        .forEach(el => {
            $(el).removeClass('panel-selection-alert');
            el.isOpen = false;
        });
};



// WEBPACK FOOTER //
// ./src/utils.js